<script setup>


import {computed, nextTick, onMounted, ref, watch} from "vue";

const props = defineProps({
    placeholder: String,
    modelValue: String | undefined,
    borderFocus: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false
    },
    type: {
        type: String,
        default: 'text'
    },
    fontSize: {
        type: String,
        default: 'sm'
    },
    textArea: {
        type: Boolean,
        default: false
    },
    background: {
        type: String,
        default: 'default'
    },
})
const emit = defineEmits(['update:modelValue', 'push', 'onFocus'])

const fontSizeClasses = computed(() => {
    return {
        'sm': 'text-sm',
        'base': 'text-base'
    }[props.fontSize]
})

const bgClasses = computed(() => {
    return {
        'default': 'bg-white dark:bg-dark-blue dark:text-slate-200',
        'white': 'bg-white'
    }[props.background]
})

const textareaRef = ref(null);

const adjustHeight = () => {
    if (!props.textArea || !textareaRef.value) return;
    textareaRef.value.style.height = 'auto';
    textareaRef.value.style.height = textareaRef.value.scrollHeight + 'px';
}

const handleInput = (event) => {
    emit('update:modelValue', event.target.value);
    adjustHeight();
}

watch(() => props.modelValue, () => {
    nextTick(adjustHeight);
});

onMounted(() => {
    adjustHeight();
});
</script>

<template>
    <div
        :class="[ textArea ? 'min-h-10' : 'h-10', {'!border-black dark:!border-slate-200': borderFocus && modelValue?.length > 0}, bgClasses]"
        class="border border-slate-300 dark:border-slate-700 rounded-lg e flex items-center px-4 w-full justify-between gap-3 transition-colors relative">
        <slot name="left-icon">
        </slot>
        <slot v-if="textArea"><textarea
            ref="textareaRef"
            rows="1"
            @input="handleInput"
            @keydown.enter.exact.prevent="$emit('push')"
            @focus="$emit('onFocus')"
            :value="modelValue" :class="[fontSizeClasses, bgClasses]" class="py-2 resize-none border-0 font-normal px-0 w-full h-full focus:ring-0 focus-visible:outline-0 placeholder:text-gray-400 dark:placeholder:text-slate-500 overflow-hidden"
            :disabled="disabled"
            :placeholder="placeholder"/></slot>

        <slot v-if="!textArea"><input
            @input="$emit('update:modelValue', $event.target.value)"
            @keydown.enter="$emit('push')"
            @focus="$emit('onFocus')"
            :value="modelValue" :class="[fontSizeClasses, bgClasses]" class="border-0 font-normal px-0 w-full h-full focus:ring-0 focus-visible:outline-0 placeholder:text-gray-400 dark:placeholder:text-slate-500"
            :type="type"
            :disabled="disabled"
            :placeholder="placeholder"></slot>
        <slot name="right-icon"></slot>
    </div>

</template>

<style scoped>

</style>
